import React from 'react';
import {ProductImage} from "./ProductImage";
import {NOT_LAZY_MAX_IMAGE_NUMBER, REVIEWS_DISPLAY_THRESHOLD} from "@/utils/constants";
import WithLazyLoadProductImage from "./ProductImage";
import {useSelector} from "react-redux";
import Utils from "@/utils/Default/Utils";
import dynamic from "next/dynamic";
import EnergyClass from "@/components/Default/Common/EnergyClass";

const PictoOpWithNoSSR = dynamic(
    () => import('../Common/PictoOp'),
    {ssr: false}
)
const ProductListAvailabilityWordingContainerWithNoSSR = dynamic(
    () => import('./ProductListAvailabilityWordingContainer'),
    {ssr: false}
)
const ListCell = ({
                      isAutoPromoBanners,
                      ean,
                      productPosition,
                      productSheetUrl,
                      id,
                      flyerId,
                      breadcrumbId,
                      getDiscountAti,
                      rangeLabel,
                      unitPriceWithoutTax,
                      title,
                      handleMouseOver,
                      handleMouseOut,
                      isHovering,
                      images,
                      brand,
                      shortTitle,
                      isRated,
                      productNote,
                      features,
                      isNewEnergyClass,
                      commercialOperations,
                      commercialSticker,
                      price,
                      priceWithoutTax,
                      originalPrice,
                      originalPriceWithoutTax,
                      discount,
                      offersNumber,
                      getOffersStateWording,
                      offersState,
                      cheapestOfferPrice,
                      cheapestOfferPriceWithoutTax,
                      soldBy,
                      availabilityDataByShops,
                      availabilityShopIdListFilter,
                      productsAvailabilityData,
                      availabilityDisplayMode,
                      productIndex,
                      filters,
                      privateSalePrice,
                      privateSalePriceWithoutTax,
                      privateDiscount,
                      metaData,
                      cheapestIsBestOffer,
                      bestOfferSellerName,
                      bestOfferSellerId,
                      maxDisplayedPicto,
                      renderShippingPictos,
                      htOptin,
                      shippingAvailibilityMkp,
                      energyClass
                  }) => {
    let customer = useSelector(state => state.header.customer);
    let eligibilityToPrivateSale = customer.eligibilityToPrivateSale
    let productOriginalPrice = originalPrice > 0 ? originalPrice : eligibilityToPrivateSale && privateSalePrice > 0 ? price : null;
    let productOriginalPriceWithoutTax = originalPriceWithoutTax > 0 ? originalPriceWithoutTax : eligibilityToPrivateSale && privateSalePrice > 0 ? priceWithoutTax : null;
    let productPrice = eligibilityToPrivateSale && privateSalePrice > 0 ? privateSalePrice : price;
    let productPriceWithoutTax = eligibilityToPrivateSale && privateSalePriceWithoutTax > 0 ? privateSalePriceWithoutTax : priceWithoutTax;
    let discountAmount = eligibilityToPrivateSale && privateDiscount > 0 ? privateDiscount : discount > 0 && originalPrice > 0 ? discount : null;
    let discountAmountClassName = eligibilityToPrivateSale && privateDiscount > 0 ? 'pricesActions__prices-private-percent' : 'pricesActions__prices-percent';
    let style = eligibilityToPrivateSale && privateDiscount > 0 ? {backgroundColor: Utils.getMetaInfosValueByCode("privateDiscountColor", metaData)} : null;
    const displayReview = soldBy !== 'MKP' ? productNote >= REVIEWS_DISPLAY_THRESHOLD : productNote > 0;

    return (
        <div key={ean} className={`product${isAutoPromoBanners ? ' ' + isAutoPromoBanners : ''}`}>
            {commercialOperations.length > 0 &&
                <PictoOpWithNoSSR
                    eligibilityToPrivateSale={eligibilityToPrivateSale}
                    commercialOperations={commercialOperations}
                    id={ean}
                    maxDisplayedPicto={maxDisplayedPicto}
                />
            }
            <a className="product__link gtm-product"
               id={"product-div-" + ean} data-cheapest-is-best-offer={cheapestIsBestOffer}
               data-gtm-product={
                   '{"product_position":"' + productPosition + '",' +
                   '"product_ean":"' + ean + '",' +
                   '"product_id":"' + id + '",' +
                   '"product_breadcrumb_id":"' + breadcrumbId + '",' + /*a verifier*/
                   '"product_op":"' + ((commercialOperations && commercialOperations["0"]) ? commercialOperations["0"].name : 'no_commercialOperation') + '",' +
                   '"numero_media":"' + ((flyerId) ? flyerId.replace('#', '::') : '') + '",' +
                   '"product_webprice_ati":' + (price ? '"' + (price.toFixed(2)) + '"' : 'null') + ',' +
                   '"product_webprice_tf":' + (unitPriceWithoutTax ? '"' + (unitPriceWithoutTax.toFixed(2)) + '"' : 'null') + ',' +
                   '"product_discount_ati":' + getDiscountAti(privateDiscount, originalPrice, price) + ',' +
                   '"product_discount_percentage":' + (discount ? '"' + discount + '"' : 'null') + ',' +
                   '"product_url_page":"' + Utils.getMetaInfosValueByCode("productSheetUrl", metaData) + '",' +
                   '"product_gamme":' + (rangeLabel ? '"' + rangeLabel + '"' : 'null') + ',' +
                   '"product_trademark":' + (brand ? '"' + brand + '"' : 'null') + ',' +
                   '"product_vendor_type":' + (soldBy ? '"' + soldBy + '"' : 'null') + ',' +
                   '"product_vendor_id":' + (soldBy === 'BUT' ? '"BUT"' : (bestOfferSellerId ? '"' + bestOfferSellerId + '"' : 'null')) + ',' +
                   '"product_vendor_name":' + (soldBy === 'BUT' ? '"BUT"' : (bestOfferSellerName ? '"' + bestOfferSellerName + '"' : 'null')) + ',' +
                   '"product_offer_nb":"' + (soldBy === 'MKP' ? offersNumber : offersNumber + 1) + '"' +
                   '}'}
               href={productSheetUrl} title={title} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut}>
                <div className="visual">
                    {
                        productIndex < NOT_LAZY_MAX_IMAGE_NUMBER ?
                            <ProductImage images={images} isHovering={isHovering}/> :
                            <WithLazyLoadProductImage images={images} isHovering={isHovering}/>
                    }
                    {!!energyClass &&
                        <EnergyClass isNewEnergyClass={isNewEnergyClass} energyClass={energyClass}/>
                    }
                </div>
                <div className="infos">
                    <p className="infos-title">
                        {brand && brand.length > 0 ? <><strong>{brand}</strong><br/></> : null}
                        <span>{shortTitle}</span></p>
                    {displayReview && <div className={`infos-rating${isRated}`}>
                        <span>({productNote})</span>
                    </div>}
                    <ul className="infos-features">
                        {features?.map((feature) =>
                            <li>{feature.label} : {feature.value}</li>
                        )}
                    </ul>
                </div>
                <div className="pricesActions">
                    {commercialSticker &&
                    <p className="pricesActions-exclusive"><span>{commercialSticker.name}</span>
                    </p>
                    }
                    <p className="pricesActions__prices">
                        <span
                            className="pricesActions__prices-price">{htOptin ? <>{parseFloat(productPriceWithoutTax).toFixed(2).replace(".", ",")} </> : <>{parseFloat(productPrice).toFixed(2).replace(".", ",")} </>}<sup>€{htOptin && <>&nbsp;HT</>}</sup></span><br/>
                        {(productOriginalPrice > 0 && (productOriginalPrice > productPrice)) &&
                            <span
                                className="pricesActions__prices-stroke">{htOptin ? <>{parseFloat(productOriginalPriceWithoutTax).toFixed(2).replace(".", ",")}</> : <>{parseFloat(productOriginalPrice).toFixed(2).replace(".", ",")}</>}<sup>€{htOptin && <>&nbsp;HT</>}</sup></span>
                        }
                        <br/>
                        {(discountAmount) &&
                        <span
                            className={discountAmountClassName} style={style}>-{discountAmount}<sup>%</sup></span>
                        }
                    </p>
                    <p className="pricesActions__availability__meet">
                        <ProductListAvailabilityWordingContainerWithNoSSR filters={filters}
                                                                          availabilityDataByShops={availabilityDataByShops}
                                                                          soldBy={soldBy} ean={ean}
                                                                          availabilityShopIdListFilter={availabilityShopIdListFilter}
                                                                          productsAvailabilityData={productsAvailabilityData}
                                                                          availabilityDisplayMode={availabilityDisplayMode}
                                                                          shippingAvailibilityMkp={shippingAvailibilityMkp}/>

                        <br/>
                        {(offersNumber > 0) &&
                            <span className="pricesActions__availability__meet-who">
                                        {offersNumber} {getOffersStateWording(offersState, offersNumber)} dès {htOptin ? <>{parseFloat(cheapestOfferPriceWithoutTax).toFixed(2).replace(".", ",")}</> : <>{parseFloat(cheapestOfferPrice).toFixed(2).replace(".", ",")}</>}
                                <sup>€{htOptin && <>&nbsp;HT</>}</sup>
                                    </span>
                        }
                    </p>
                    <div className="pricesActions__free-shipping">
                        {renderShippingPictos()}
                    </div>
                    <button title="Voir ce produit" className="pricesActions-addCart">Voir ce
                        produit
                    </button>
                    {(soldBy === 'BUT') &&
                    <p className="pricesActions-soldBy">Vendu par <span
                        className="but">BUT</span></p>
                    }
                    {(soldBy === 'MKP') &&
                    <p className="pricesActions-soldBy">Vendu
                        par <span>{bestOfferSellerName}</span>
                        {(offersNumber > 1) ? <span>  (+{offersNumber - 1} offres)</span> :
                            <span> (+{offersNumber} offre)</span>}
                    </p>
                    }
                    {(soldBy === 'BUT_MKP') &&
                    <p className="pricesActions-soldBy">Vendu par <span
                        className="but">BUT </span>
                        {(offersNumber > 1) ? <span> (+{offersNumber} offres)</span> :
                            <span>(+{offersNumber} offre)</span>}
                    </p>
                    }
                </div>
            </a>
        </div>
    );
}

export default ListCell;
